export default {
    title: `Porter un regard neuf sur le monde`,

    subTitleEN: `Patrick Folléa, directeur de Société Générale Private Banking`,
    subTitleFR: `Mathieu Vedrenne, directeur de Société Générale Private Banking France`,
    subTitleMC: `Alexandre Rousseau, directeur de Société Générale Private Banking Monaco`,
    subTitleLU: `Olivier Lecler, directeur de Société Générale Private Banking Luxembourg`,
    subTitleCH: `Franck Bonin, directeur de Société Générale Private Banking Suisse`,

    mainContent: `
    <p>
        Ce numéro de PB a été composé avant la crise du coronavirus. <br/>
        Et pourtant, au moment de valider sa publication, nous n’en avons pas changé une ligne. Dans son esprit comme dans son contenu, il nous a semblé qu’il reflétait bien les enjeux du moment.
    </p>
    <p>
        Cette crise brutale affecte chacun de nous dans sa vie personnelle et professionnelle. Pourtant, à côté de sa « face sombre » et de ses victimes, elle constitue un formidable terrain d’innovations et de solidarité. <br/>
        Parce qu’elle nous oblige à penser autrement, par les interrogations qu’elle suscite, par les remises en cause qu’elle provoque, par les avancées qu’elle génère, elle est aussi l’occasion d’un possible renouveau. À tout le moins, de porter un regard neuf sur notre environnement.
    </p>
    <p>
        À notre modeste niveau, en donnant la parole à des hommes et à des femmes engagés dans la transformation positive du monde, c’est aussi ce que nous tentons de faire, depuis sa création voici deux ans, avec notre magazine.
    </p>
    <p>
        J’espère que vous trouverez de l’intérêt à ce nouveau numéro et je vous souhaite, malgré le contexte si particulier, un très bon été.
    </p>`,

};

